// extracted by mini-css-extract-plugin
module.exports = {"root":"ImpersonationLabel_root__3dRVj"};